import dynamic from 'next/dynamic';

export const RateListMI = dynamic(() => import('./RateListMI').then(module => module.default));
